import classNames from 'classnames';
import React from 'react';

export const FieldItem = ({children, className, style, ref}) => {
    return (
        <div className={classNames('field-item', className)} ref={ref} style={style}>
            { children }
        </div>
    )
}